
/* eslint-disable */
import postsQuery from '~/apollo/queries/posts'

export default {
  props: { clienti: { type: Array, required: true, default: () => [] } },
  data() {
    return {
      urls: []
    }
  },
  async fetch () {
    for(const c of this.clienti) {
        const data = await this.$graphql.default.request(postsQuery)
        const arrayRet = []
        if (data.posts.edges !== undefined && data.posts.edges !== null) {
          for (let i = 0; i < data.posts.edges.length; i++) {
            const post = data.posts.edges[i]
            const clienti = post.node.clienti.edges
            for (let z = 0; z < clienti.length; z++) {
              const set = clienti[z]
              if (set.node.slug === c.nome[0].slug) { arrayRet.push(post) }
            }
          }

        }

        if(arrayRet.length > 0) {
          this.urls.push({[c.nome[0].slug]:'/progetti/cliente/'+ c.nome[0].slug})
        } else {
          this.urls.push({[c.nome[0].slug]:'/agenzia-di-comunicazione'})
        }
      }
  },
  methods: {
    getUrl(c) {
      let link = '';
      for(const url of this.urls) {
        for(const [key, value] of Object.entries(url)) {
          if(key === c.nome[0].slug) {
            link = value + '/'
          }
        }
      }
      return link
    }
    // splitUrl (url) {
    //   let tmp = (url !== null) ? url : false
    //   if (tmp) {
    //     const split = tmp.split('https://dna.studio375.it/wp-content')
    //     tmp = split[1]
    //   }
    //   return tmp
    // }
  }
}
